import { onSelect, onSelectAll } from '../utils/dom'

const OBJ_HOVER = {
  networkSolutions: onSelectAll('[data-js-hover]'),
}

OBJ_HOVER.networkSolutions.forEach((pointer) => {
  let image = onSelect('img', pointer)

  if (image !== null) {
    let width = image.clientWidth
    let height = image.clientHeight

    pointer.addEventListener('mousemove', (event) => {
      const { layerX, layerY } = event
      const rotationY = ((layerX - width / 2) / width) * 20
      const rotationX = ((layerY - height / 2) / height) * 20

      const string3D = `
        translate(-50%, -50%)
        perspective(800px)
        scale(1.08)
        rotateX(${rotationX}deg)
        rotateY(${rotationY}deg)
      `

      image.style.transform = string3D
    })

    pointer.addEventListener('mouseout', (event) => {
      image.style.transform = `
        translate(-50%, -50%)
        perspective(800px)
        scale(1)
        rotateX(0)
        rotateY(0)
      `
    })
  }
})
